import { Box, Button } from "@mui/material";
import "../../../src/index.css";
import {
  DashBoardCardColors,
  DashBoardHeaderCardColors,
} from "../../utils/constants";
import MedicineShortage from "../../assets/icon/MedicineShortage.svg";
import sale from "../../assets/icon/sale.svg";
import MonthlyRevenue from "../../assets/icon/MonthlyRevenue.svg";
import HeaderItem from "../dashboard-screen/doctor-dashboard/header-item";
import medicine from "../../assets/icon/medicine.svg";
import allProduct from "../../assets/icon/allProduct.svg";
import totalCost from "../../assets/icon/totalCost.svg";
import GoToIcon from "../IconComp/goToIcon";
import React from "react";
import Calendar from "./calender";
import { useNavigate } from "react-router-dom";
import { NavigateOptions } from "react-router-dom";

interface IProps {
  doctorStats: any;
}
const HeaderInfo = ({ doctorStats }: IProps) => {
  const todaySale = doctorStats?.dashboardStatsDetails?.todays_sales;
  const formattedTodaySale = todaySale?.toLocaleString("en-IN");
  const monthlyRevenue = doctorStats?.dashboardStatsDetails?.monthly_revenue;
  const formattedMonthlyRevenue = monthlyRevenue?.toLocaleString("en-IN");
  const totalProductsAvailable =
    doctorStats?.dashboardStatsDetails?.available_product?.toLocaleString(
      "en-IN"
    );
  const totalMedicalProductsAvailable =
    doctorStats?.dashboardStatsDetails?.available_med_product?.toLocaleString(
      "en-IN"
    );
  const totalNonMedicalProductsAvailable =
    doctorStats?.dashboardStatsDetails?.available_non_med_product?.toLocaleString(
      "en-IN"
    );
  const totalProductsCost =
    doctorStats?.dashboardStatsDetails?.available_stock_cost?.toLocaleString(
      "en-IN"
    );
  const medicineShortage =
    doctorStats?.dashboardStatsDetails?.medicicne_shortage?.length;

  const navigate = useNavigate();

  const handleResolve = () => {
    const navigateOptions: NavigateOptions = { state: { fromResolve: true } };
    navigate("/dashboard/medicines", navigateOptions);
  };
  const handleSales = () => {
    navigate("/dashboard/saleshistory");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
        gap: 2,
        flexWrap: "wrap",
        py: 2,
      }}
    >
      <Box
        className="dashboardCard"
        sx={{
          bgcolor: DashBoardHeaderCardColors.sale.primary,
          borderRadius: "5px",
          pb: "33px",
        }}
      >
        <HeaderItem
          Image={sale}
          title="Today's Net Sale"
          value={formattedTodaySale ? `Rs. ${formattedTodaySale}` : 0}
          color={DashBoardCardColors.Patient.secondary}
        />
      </Box>
      <Box
        className="dashboardCard"
        sx={{
          bgcolor: DashBoardHeaderCardColors.revenue.primary,
          borderRadius: "5px",
          pb: "33px",
          position: "relative",
        }}
      >
        <HeaderItem
          Image={MonthlyRevenue}
          title="Monthly Revenue"
          value={formattedMonthlyRevenue ? `Rs. ${formattedMonthlyRevenue}` : 0}
          color={DashBoardCardColors.Doctor.secondary}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
          }}
          onClick={handleSales}
        >
          <Button style={{ listStyle: "none", fontSize: "12px" }}>
            View Details
          </Button>
        </Box>
      </Box>
      <Box
        className="dashboardCard"
        sx={{
          bgcolor: DashBoardHeaderCardColors.allProducts.primary,
          borderRadius: "5px",
          pb: "36px",
        }}
      >
        <HeaderItem
          Image={allProduct}
          value={totalProductsAvailable ? totalProductsAvailable : 0}
          title="All Products"
          color={DashBoardCardColors.Clinic.secondary}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            "@media (max-width:1300px)": {
              flexDirection: "column",
            },
            justifyContent: "center", // Centers items horizontally
            alignItems: "center", // Centers items vertically
          }}
        >
          <Box
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Medical: {totalMedicalProductsAvailable}
          </Box>
          <Box
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              textAlign: "center",
              "@media (max-width:1300px)": {
                display: "none", 
              },
            }}
          >
            &nbsp;|&nbsp;
          </Box>
          <Box
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Non-Medical: {totalNonMedicalProductsAvailable}
          </Box>
        </Box>
      </Box>

      <Box
        className="dashboardCard"
        sx={{
          bgcolor: DashBoardHeaderCardColors.totalCost.primary,
          borderRadius: "5px",
          pb: "36px",
        }}
      >
        <HeaderItem
          Image={totalCost}
          value={totalProductsCost ? totalProductsCost : 0}
          title="Total Cost"
          color={DashBoardCardColors.Clinic.secondary}
        />
      </Box>

      <Box
        className="dashboardCard"
        sx={{
          bgcolor: DashBoardHeaderCardColors.medShortage.primary,
          borderRadius: "5px",
          border: "1px solid #F0483E",
        }}
      >
        <HeaderItem
          Image={MedicineShortage}
          value={medicineShortage ? medicineShortage : 0}
          title="Medicine Shortage"
          color={DashBoardCardColors.Hospital.secondary}
          button={
            <React.Fragment>
              Resolve Now <GoToIcon />
            </React.Fragment>
          }
          onClick={handleResolve}
        />
      </Box>
    </Box>
  );
};

export default HeaderInfo;
